import { Status, StatusTypes } from "../../../types/statusTypes";
import { TagsResponse, TagStatusType } from "../../../types/tagTypes";

export const getMockTagStatus = (
  status: Status = StatusTypes.healthy,
): TagStatusType => ({
  tag_code: "PSV-1015-01A-3P",
  status,
  tag_type: "SCE-ONLY",
});

const mockCto = {
  cto_number: "",
  cto_status: 0,
  current_step: 1,
};

export const defaultTagResponse: TagsResponse = {
  ctos: [],
  cto: {
    cto_number: "CTO-000",
    cto_status: 0,
    current_step: 1,
  },
  sces: ["DC-01"],
  open_wos: [],
  redundant_tags: 0,
  tag_family_status_code: -1,
  tag_status_code: -1,
  tag_code: "",
  tag_name: "",
  tag_family_code: "",
  tag_ref_drawing: "",
  moc_number: "MOC-002",
  moc_status: "Implemented - Awaiting Closeout Checklist Completion",
  mahs: [
    { code: "MAH-001", name: "description MAH-001", barriers: "BARRIER-001" },
    { code: "MAH-005", name: "description MAH-005", barriers: "BARRIER-001" },
  ],
  wos: {
    status: "HEALTHY",
    open_wos: null,
  },
  sensor: {
    status: "HEALTHY",
    updated_at: null,
  },
  barriers: [
    {
      code: "BARRIER-001",
      name: "description BARRIER-001",
      status_code: -1,
      status_color: "red",
      status_label: "",
    },
  ],
  hcs: [],
  tag_type: "SCE-ONLY",
};

export const mockTagsResponse: TagsResponse = {
  ...defaultTagResponse,
  ctos: ["CTO-000"],
  tag_code: "PSE-2110A-03-1S",
  tag_family_code: "PSE-2110A",
  tag_name: "Rupture Disk, VRU 1ST STAGE COMPRESSOR - A",
  tag_ref_drawing: "0428-90-2100-G12-0016",
  barriers: [],
};

export const mockFetchFullTagsResponse: TagsResponse[] = [
  {
    ...defaultTagResponse,
    ctos: ["CTO-000"],
    cto: {
      cto_number: "CTO-000",
      cto_status: 0,
      current_step: 1,
    },
    tag_code: "PSE-2110A-03-1S",
    tag_family_code: "PSE-2110A",
    tag_name: "Rupture Disk, VRU 1ST STAGE COMPRESSOR - A",
    tag_ref_drawing: "0428-90-2100-G12-0016",
  },
  {
    ...defaultTagResponse,
    cto: mockCto,
    sces: ["DC-01", "DC-02"],
    open_wos: ["000004418016", "000004418017"],
    redundant_tags: 2,
    tag_code: "PSV-1015-01A-3P",
    tag_family_code: null,
    tag_name: "Pressure Safety Valve, FREEWATER KO DRUM OUTLET",
    tag_ref_drawing: "0428-MI20-90DP-3170",
  },
  {
    ...defaultTagResponse,
    cto: mockCto,
    open_wos: ["000405013506"],
    redundant_tags: 1,
    tag_code: "PSV-1020-01B-3P",
    tag_family_code: "PSV-1020",
    tag_name: "Pressure Safety Valve, TEST INLET HEATER",
    tag_ref_drawing: "0428-MI20-90DP-3169",
  },
  {
    ...defaultTagResponse,
    cto: mockCto,
    tag_code: "PSV-1053-01-1PW",
    tag_family_code: "PSV-1053",
    tag_name:
      "Pressure Safety Valve, FLEXIBLE RISER CRCS VENT-OVERBOARD \n(BY PETROBRAS)",
    tag_ref_drawing: "",
  },
  {
    ...defaultTagResponse,
    cto: mockCto,
    tag_code: "PSV-1057-01-3PW",
    tag_family_code: "PSV-1057",
    tag_name:
      "Pressure Safety Valve, FLEXIBLE RISER CRCS VENT OVERBOARD\n(BY PETROBRAS)",
    tag_ref_drawing: "",
  },
  {
    ...defaultTagResponse,
    cto: mockCto,
    tag_code: "PSV-1110B-01-2P",
    tag_family_code: "PSV-1110B",
    tag_name: "Pressure Safety Valve, CRUDE/ CRUDE EXCHANGER OUTLET",
    tag_ref_drawing: "0428-MI20-90DP-3180",
  },
  {
    ...defaultTagResponse,
    cto: mockCto,
    redundant_tags: 1,
    tag_code: "PSV-1130-01B-2P",
    tag_family_code: "PSV-1130",
    tag_name: "Pressure Safety Valve, ELECTROSTATIC TREATER 1ST STAGE OUTLET ",
    tag_ref_drawing: "0428-MI20-90DP-3190",
  },
  {
    ...defaultTagResponse,
    cto: mockCto,
    open_wos: ["000405115452"],
    tag_code: "PSV-1135A-01-2P",
    tag_family_code: "PSV-1135A",
    tag_name:
      "Pressure Safety Valve, ELECTROSTATIC TREATER 1ST STAGE WATER PUMP OUTLET ",
    tag_ref_drawing: "0428-MI20-90DP-3191",
  },
  {
    ...defaultTagResponse,
    cto: mockCto,
    open_wos: ["000405115454"],
    redundant_tags: 1,
    tag_code: "PSV-1150-01B-2P",
    tag_family_code: "PSV-1150",
    tag_name: "Pressure Safety Valve, ELECTROSTATIC TREATER 2ND STAGE OUTLET",
    tag_ref_drawing: "0428-MI20-90DP-3193",
  },
  {
    ...defaultTagResponse,
    cto: mockCto,
    redundant_tags: 1,
    tag_code: "PSV-1195-01B-2P",
    tag_family_code: "PSV-1195",
    tag_name: "Pressure Safety Valve, DILUTION WATER HEATER",
    tag_ref_drawing: "0428-MI20-90DP-3194",
  },
  {
    ...defaultTagResponse,
    cto: mockCto,
    redundant_tags: 3,
    tag_code: "PSV-1198-68D-2P",
    tag_family_code: "PSV-1198",
    tag_name:
      "Pressure Safety Valve, FISCAL OIL METERING SKID\nSTRAINER D OUTLET ",
    tag_ref_drawing: "0428-50-9040-G12-0123",
  },
];
